import { notifyOnError } from '~/rage/decorators';
import { ClientError, ClientErrorCode } from '~/shared';

import { IAccountsService } from './accountsServiceTypes';

export class AccountsServiceStub implements IAccountsService {
	public async login(
		emailOrLogin: string,
		password: string,
		remember = false,
	): Promise<void> {
		console.log('login', {
			emailOrLogin,
			password,
			remember,
		});

		if (emailOrLogin === 'test1') {
			throw new ClientError(ClientErrorCode.AccountNotFound);
		}

		if (emailOrLogin === 'test2') {
			throw new ClientError(ClientErrorCode.WrongPassword);
		}

		if (emailOrLogin === 'test3') {
			throw new Error('Some error');
		}

		await new Promise((resolve) => setTimeout(resolve, 1000));
	}

	public async restorePassword(
		email: string,
		login: string,
	): Promise<{ resendAvailableAt: number; maskedEmail: string }> {
		console.log('restorePassword', {
			email,
			login,
		});

		await new Promise((resolve) => setTimeout(resolve, 500));

		return {
			resendAvailableAt: Date.now() + 60_000,
			maskedEmail: 'te***@gmail.com',
		};
	}

	private randomHex(size: number): string {
		const bytes = new Uint8Array(size);
		crypto.getRandomValues(bytes);
		return Array.from(bytes)
			.map((b) => b.toString(16).padStart(2, '0'))
			.join('');
	}

	public async confirmResetCode(
		email: string,
		code: string,
	): Promise<{ token: string; expiresAt: number }> {
		console.log('confirmResetCode', {
			email,
			code,
		});

		await new Promise((resolve) => setTimeout(resolve, 500));

		return {
			token: 'stub-reset-token-' + this.randomHex(8),
			expiresAt: Date.now() + 15 * 60 * 1000,
		};
	}

	public async resetPassword(
		email: string,
		token: string,
		newPassword: string,
	): Promise<void> {
		console.log('resetPassword', {
			email,
			token,
			newPassword,
		});

		await new Promise((resolve) => setTimeout(resolve, 500));
	}

	public async sendRegistrationCode(
		email: string,
		login: string,
		password: string,
	): Promise<{ resendAvailableAt: number; maskedEmail: string }> {
		console.log('sendRegistrationCode', { email, login, password });
		await new Promise((resolve) => setTimeout(resolve, 500));
		return {
			resendAvailableAt: Date.now() + 60_000,
			maskedEmail: 'te***@gmail.com',
		};
	}

	public async confirmRegistrationCode(
		email: string,
		code: string,
	): Promise<{
		createdAt: number;
		accountId: string;
		resetToken?: string;
		expiresAt?: number;
	}> {
		console.log('confirmRegistrationCode', { email, code });
		await new Promise((resolve) => setTimeout(resolve, 500));
		return {
			createdAt: Date.now(),
			accountId: 'stub-account-' + this.randomHex(4),
		};
	}

	public async verifyServerPassword(password: string): Promise<void> {
		console.log('verifyServerPassword', {
			password,
		});

		await new Promise((resolve) => setTimeout(resolve, 1000));

		if (password === 'test') {
			console.log('OK');
		} else {
			throw new ClientError(ClientErrorCode.WrongServerPassword);
		}
	}

	@notifyOnError
	public async verifyClosedBetaCode(code: string): Promise<void> {
		console.log('verifyClosedBetaCode', { code });

		await new Promise((resolve) => setTimeout(resolve, 1000));

		if (code !== 'test') {
			throw new ClientError(ClientErrorCode.WrongClosedBetaCode);
		}
	}
}
